import TabPanel from '@mui/lab/TabPanel/TabPanel';
import { Divider, Tab, Tabs, Typography, styled } from '@mui/material';

export const FacilityTabPanel = styled(TabPanel)`
  padding: 30px 0px;
`;

export const FacilityDivider = styled(Divider)`
  width: 100%;
  margin: auto;
`;

export const InfoText = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: #79767d;
`;

export const TabText = styled(Tab)`
  font-size: 16px;
  margin-bottom: 12px;
  flex: 1;
`;

export const CategoryTab = styled(Tab)`
  justify-content: space-between;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e7e5e9;
  text-align: start;
  padding: 20px;
  margin-bottom: 16px;
  p {
    color: #48464c;
    font-size: 16px;
    font-weight: 700;
  }
  b {
    font-size: 14px;
    color: #79767d;
    font-weight: 500;
    width: 210px;
  }
  &.Mui-selected,
  &.Mui-selected:hover {
    background-color: #f5f7fe;
    border: 2px solid #5546a9;
    /* border-right: none; */
    p {
      color: #5546a9;
    }
  }
`;

export const CategoryTabs = styled(Tabs)`
  span {
    display: none;
  }
`;
